import { TypeOfEtity } from '../model/enum/typeOfEntity';

export const handleSelectLink = (item: any, navigate: any) => {
    if (item?.tip === TypeOfEtity.Kategorija) {
        navigate(`/user/kategorija/${item?.id}`);
    }
    if (item?.tip === TypeOfEtity.Podkategorija) {
        navigate(`/user/podkategorija/${item?.id}`);
    }
    if (item?.tip === TypeOfEtity.SkupOblasti) {
        navigate(`/user/skup-oblasti/${item?.id}`);
    }
    if (item?.tip === TypeOfEtity.Oblast) {
        navigate(`/user/oblast/${item?.id}`);
    }
    if (item?.tip === TypeOfEtity.Podoblast) {
        navigate(`/user/podoblast/${item?.id}`);
    }
    if (item?.tip === TypeOfEtity.Lekcija) {
        navigate(`/user/lekcija/${item?.id}`);
    }
};
